import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-ExtraLightItalicNew.woff2';
import woff from '../src/PPMori-ExtraLightItalicNew.woff';

export const ppMoriExtraLightItalic: FontFaceSpec = {
  weight: 200,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
